import { API_BASE_URL, ENDPOINTS } from "@/config/api.enpoints";
import apiClient from "./apiClient";
import type { INotification, Paginated } from "@/types/notification";
import useAuthStore from "@/store/useAuthStore";
const userId = useAuthStore.getState().id;

export const getUnreadCount = async (): Promise<number> => {
  const { data } = await apiClient.get(
    `${API_BASE_URL}${ENDPOINTS.NOTIFICATION.unReadCount}`,
  );
  return data?.data?.unreadCount || 0;
};

export const getAllNotificaition = async (
  page = 1,
  limit = 2,
  unRead?: string,
): Promise<Paginated<INotification>> => {
  const params: Record<string, string | number | boolean | undefined> = {
    page,
    limit,
    userId,
  };

  if (unRead === "true" || unRead === "false") {
    params.unreadOnly = unRead === "true";
  }

  const { data } = await apiClient.get(
    `${API_BASE_URL}${ENDPOINTS.NOTIFICATION.getNotifications}`,
    { params },
  );

  return data?.data;
};

export const markAllNotificationAsRead = async (
  userId: string,
): Promise<void> => {
  await apiClient.post(`${API_BASE_URL}${ENDPOINTS.NOTIFICATION.markAsRead}`, {
    userId,
  });
};

export const markAnyNotificationAsRead = async (id: string): Promise<void> => {
  await apiClient.post(
    `${API_BASE_URL}${ENDPOINTS.NOTIFICATION.markNotificationAsRead(id)}`,
  );
};
